import { FC } from 'react';
import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import { Link, Typography } from '@loomstateorg/shared-frontend';
import useImageSizes from '@loomstateorg/shared-frontend/hooks/useImageSizes';
import Image from 'frontastic/lib/image';
import { ContentSliderSlideProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-slider/types';

const ContentSliderSlide: FC<ContentSliderSlideProps & { index?: number }> = ({
  image,
  title,
  ctaLabel,
  summary,
  ctaReference,
  index = 0,
}) => {
  const tileImageSizes = useImageSizes({ md: 1, lg: 0.33, defaultSize: 0.33 });

  return (
    <Link link={ctaReference} className="w-full overflow-hidden" data-testid={`content-slide-${index}`}>
      {image && (
        <div className="relative h-220 md:h-356">
          <div className="absolute z-10 size-full rounded-md bg-black opacity-20"></div>
          <Image
            {...image}
            sizes={tileImageSizes}
            className="mb-5 rounded-md"
            fill={true}
            style={{ objectFit: 'cover' }}
          />
        </div>
      )}
      {title && (
        <Typography
          as="h4"
          fontSize={20}
          fontFamily="libre"
          className="mt-12 max-w-[90%] overflow-hidden text-ellipsis whitespace-pre text-primary-regular"
          data-testid={`content-slide-title-${index}`}
        >
          {title}
        </Typography>
      )}
      {summary && (
        <Typography as="p" fontSize={16} fontFamily="inter" className="mt-12 leading-[24px]">
          {summary}
        </Typography>
      )}
      {ctaLabel && (
        <div className="mt-20 flex gap-1.5">
          <Typography fontSize={16} className="hidden text-black md:block">
            {ctaLabel}
          </Typography>
          <ArrowLongRightIcon className="mt-2 h-20 w-24 text-secondary-regular" />
        </div>
      )}
    </Link>
  );
};

export default ContentSliderSlide;
